import { Component, OnInit, Input, Output, EventEmitter, ViewChild, ElementRef } from '@angular/core';
import { DepartmentViewModel } from '@app/_models/_viewModels/department.viewmodel';
import { UploadFile, NzMessageService } from 'ng-zorro-antd';
import { Media } from '@app/_models/_DTOs/media';
import { environment } from '@environments/environment';
import { NgForm } from '@angular/forms';
import { HttpEventType } from '@angular/common/http';
import { Department } from '@app/_models/_DTOs/department';
import { ResizeService } from '@app/_services/resize.service';
import { DocumentService } from '@app/_services/document.service';
import { Location } from '@app/_models/_DTOs/location';
import { SCREEN_SIZE } from '@app/_helpers/screen-size.enum';
import { AutonumericOptions } from '@angularfy/autonumeric/lib/autonumeric.model';
import { ZXingScannerComponent } from '@zxing/ngx-scanner';
import { DepartmentService } from '@app/_services/department.service';
import { DepartmentEditorComponent } from '../department-editor/department-editor.component';


@Component({
  selector: "app-department-editor-drawer",
  templateUrl: "./department-editor-drawer.component.html",
  styleUrls: ["./department-editor-drawer.component.css"],
})
export class DepartmentEditorDrawerComponent implements OnInit {
  @Input() hiddenFields: string[];
  @Input() disabledFields: string[];
  @Input() departmentViewModel: DepartmentViewModel;
  @Input() isEditing: boolean;
  @Output() drawerClosed = new EventEmitter<boolean>();

  @ViewChild(DepartmentEditorComponent, { static: false })
  private departmentEditorComponent: DepartmentEditorComponent;

  public createForm: NgForm;

  drawerWidth: string;

  isSavingDepartment: boolean = false;

  errorMessages = {};

  apiUrl: string;

  private delayTimer;

  constructor(
    private departmentService: DepartmentService,
    private messageService: NzMessageService,
    private resizeService: ResizeService
  ) {
    this.apiUrl = environment.apiUrl;
    this.resizeService.onResize$.subscribe((size) => {
      this.drawerWidth = this.resizeService.getDrawerWidth();
    });
  }

  ngOnInit() {
    if (this.resizeService.currentSize != null) {
      this.drawerWidth = this.resizeService.getDrawerWidth();
    }
  }

  closeDrawer(departmentId?: number) {
    this.departmentEditorComponent.resetForm();
    this.drawerClosed.emit(departmentId != null);
  }
}
